import {
  ApiMutualFundAsset,
  ApiMutualFundAssetRead,
  ApiSegregatedPortfolioAsset,
  ApiSegregatedPortfolioAssetRead
} from 'api/rtk-api'
import { useEffect, useState } from 'react'

import {
  AssetInformationModal,
  Attribute,
  MessageBox,
  Numeric,
  Percent,
  Section,
  Space,
  WeightsColumns
} from '@/components/core-v2'
import { PORTFOLIO_TYPE } from '@/constants'

import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { unpascal } from '../../../util'
import { actions as rawActions } from '../state/portfolio-slice'

const PortfolioDetailsSummary = () => {
  const [inspectingAsset, setInspectingAsset] = useState<
    ApiSegregatedPortfolioAsset | ApiMutualFundAsset
  >()
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.portfolio)
  const actions = useActions(rawActions)
  const portfolioType = state?.portfolioType
  const modelPortfolio = state?.model?.portfolio
  const selfSelectPortfolio = state?.selfSelect?.portfolio
  const isFof = portfolioType === PORTFOLIO_TYPE.FundOfFunds.key
  const isModelOrFundOfFunds = portfolioType === PORTFOLIO_TYPE.ModelPortfolio.key || isFof
  const targetWeights = isModelOrFundOfFunds
    ? modelPortfolio?.targetWeights
    : selfSelectPortfolio?.targetWeights
  const rebalDef = isModelOrFundOfFunds
    ? modelPortfolio?.rebalancingDefinition
    : selfSelectPortfolio?.rebalancingDefinition

  useEffect(() => {
    actions.init(builderState.note)
  }, [actions, builderState.note])

  return (
    <>
      {(state.model || state.selfSelect) && (
        <Space mx={5} my={6}>
          {isModelOrFundOfFunds && (
            <Attribute name="Name">{modelPortfolio?.portfolioName}</Attribute>
          )}

          <Attribute name="Type">{PORTFOLIO_TYPE[portfolioType]?.value}</Attribute>

          <Attribute name="Rebalancing">{rebalDef.type}</Attribute>
          {rebalDef.type === 'Frequency' && (
            <Attribute name="Rebalancing frequency">{unpascal(rebalDef.frequency)}</Attribute>
          )}

          {rebalDef.type === 'Weight' && (
            <Attribute name="Rebalancing tolerance">
              <Percent fixed numDecimalPlaces={2} value={rebalDef.weightsTolerance * 100} />
            </Attribute>
          )}
          {isModelOrFundOfFunds && (
            <>
              <Attribute name="ID">{modelPortfolio.portfolioId}</Attribute>
              <Attribute name="Portfolio multiplier">
                <Numeric value={modelPortfolio.multiplier} />
              </Attribute>
              <Attribute name="Tax classification">{modelPortfolio.taxClassification}</Attribute>
            </>
          )}

          <AssetInformationModal
            assetId={inspectingAsset?.assetId}
            isOpen={Boolean(inspectingAsset)}
            onClose={() => setInspectingAsset(undefined)}
          />

          <Section mt={5} type="primary">
            <WeightsColumns
              isFundOfFunds={isFof}
              portfolio={modelPortfolio}
              targetWeights={targetWeights}
              onClickAsset={(asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead) =>
                setInspectingAsset(asset)
              }
            />
          </Section>
        </Space>
      )}
      {state.model === undefined && state.selfSelect === undefined && (
        <Space mx={5} my={6}>
          <MessageBox state="warning" title="A portfolio does not yet exist for this trade">
            Please edit the trade and add a portfolio
          </MessageBox>
        </Space>
      )}
    </>
  )
}

export default PortfolioDetailsSummary
